import type {QueryClient} from '@tanstack/react-query'

import {buildFieldMetricsQueryKey} from '../queries/query-keys'
import type {FieldMetricsQueryData, PaginatedMemexItemsQueryVariables} from '../queries/types'

/**
 * A wrapper around setQueryData for setting field metrics data for a view

 * @param queryClient
 * @param variables PaginatedMemexItemsQueryVariables used in the query key
 * @param queryData The new field metrics data
 */
export function setFieldMetricsQueryData(
  queryClient: QueryClient,
  variables: PaginatedMemexItemsQueryVariables,
  newQueryData: FieldMetricsQueryData,
) {
  const queryKey = buildFieldMetricsQueryKey(variables)
  queryClient.setQueryData<FieldMetricsQueryData>(queryKey, newQueryData)
}
